module.exports = __webpack_public_path__ + "img/moderation_fail_my.e9c09c50.svg";